import $ from 'jquery';
import 'magnific-popup';
import './Language/magnific-popup'

(function () {
    var lightboxes = $('a.lightbox');
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
}());
